import type { CoreApiError, UserMeModel } from '@lqa-frontend/api-services';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import {
	coreApiClient,
	coreApiQueryKey,
	endpoints,
} from '@lqa-frontend/api-services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';

export function useLoginMutation(props?: UseLoginMutationOptions) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: coreApiQueryKey(endpoints.authentication.login, 'post'),
		mutationFn: async (rq) =>
			coreApiClient.post(endpoints.authentication.login, rq.data),
		...props,
		onSuccess: async (result, variables, onMutateResult, context) => {
			props?.onSuccess?.(result, variables, onMutateResult, context);
			await queryClient.invalidateQueries();
		},
	});
}

type UseLoginMutationOptions = UseMutationOptions<
	AxiosResponse<LoginMutationResult>,
	AxiosError<CoreApiError>,
	LoginRequest
>;

export const loginDataSchema = z.object({
	username: z.string().trim().min(1),
	password: z.string().min(1),
});

export type LoginRequest = {
	data: z.infer<typeof loginDataSchema>;
};

export interface LoginMutationResult {
	accessToken: string;
	user: UserMeModel;
}
